'use client'

import { ArrowDownRight } from 'lucide-react'
import RichText from '@/components/richText'
import { ImageBlock } from '@/components/common/ImageBlock'
import LinkWrapper from '@/components/common/LinkWrapper'
import { useTranslations } from 'next-intl'
import { HeroFullScreenBlockProps, ImageBlock as ImageBlockType } from '@/payload-types'
import { useMemo } from 'react'

type ExtendedProps = Pick<HeroFullScreenBlockProps, 'heading' | 'subHeading' | 'link'> & {
  hydratedImages: (ImageBlockType | null)[]
  initialIndex: number
}
const HeroFullScreenClient = ({
  hydratedImages,
  initialIndex,
  heading,
  subHeading,
  link,
}: ExtendedProps) => {
  const t = useTranslations()

  // Use the index provided by server - same for both server render and client hydration
  const selectedImage = useMemo(() => hydratedImages[initialIndex] || null, [])

  return (
    <div className='container-max mx-auto'>
      <div className='relative flex h-[calc(100vh_-_250px)] min-h-[300px] w-full overflow-hidden rounded-3xl md:max-h-[calc(100vh_-_180px)] lg:h-full'>
        {selectedImage && typeof selectedImage !== 'string' && (
          <ImageBlock
            imageBlock={selectedImage}
            ratio={2 / 1}
            fill
            priority
            imgClassName='object-cover rounded-md lg:rounded-2xl h-full'
            className='h-full w-full object-cover'
          />
        )}

        <div className='absolute top-0 left-0 h-full w-full rounded-md bg-gradient-to-t from-black from-25% to-transparent opacity-50 lg:rounded-2xl' />

        {/*<div className='absolute w-full flex justify-center left-6 bottom-6 md:left-12 lg:left-0 md:bottom-40'>*/}
        <div className='absolute inset-0 flex w-full items-end justify-center p-6 md:pl-12 lg:pb-40'>
          <div className='flex w-full max-w-5xl flex-col space-y-4'>
            <div className='space-y-4'>
              <div className='font-alpina font-medium text-white'>
                <RichText data={heading} />
              </div>
              {subHeading && <h3 className='text-white'>{subHeading}</h3>}
            </div>

            {link && (
              <LinkWrapper
                link={link}
                className='flex w-fit items-center space-x-1 text-xl text-stone-300 underline'
              >
                <p>{link.label}</p>
                <ArrowDownRight />
              </LinkWrapper>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default HeroFullScreenClient
